import { createDecorator } from '../../instantiation/common/instantiation.js';
export * from '../../../base/parts/quickinput/common/quickInput.js';
export const IQuickInputService = createDecorator('quickInputService');
